import { SVGProps } from "react";

export default function StripeSuccessInfoIcon(
  props: SVGProps<SVGSVGElement>
) {
  const { height = 32, width = 32, stroke = "#444D5A", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.3319 3.26667C15.2652 2.48 16.7719 2.48 17.6785 3.26667L19.7852 5.06667C20.1852 5.4 20.9452 5.68 21.4785 5.68H23.7452C25.1585 5.68 26.3185 6.84 26.3185 8.25333V10.52C26.3185 11.0533 26.5985 11.8 26.9319 12.2L28.7319 14.3067C29.5185 15.24 29.5185 16.7467 28.7319 17.6533L26.9319 19.76C26.5985 20.16 26.3185 20.9067 26.3185 21.44V23.7067C26.3185 25.12 25.1585 26.28 23.7452 26.28H21.4785C20.9452 26.28 20.1985 26.56 19.7985 26.8933L17.6919 28.6933C16.7585 29.48 15.2519 29.48 14.3452 28.6933L12.2385 26.8933C11.8385 26.56 11.0785 26.28 10.5585 26.28H8.22521C6.81188 26.28 5.65187 25.12 5.65187 23.7067V21.4267C5.65187 20.9067 5.38521 20.1467 5.05187 19.76L3.25188 17.64C2.47854 16.72 2.47854 15.2267 3.25188 14.3067L5.05187 12.1867C5.38521 11.7867 5.65187 11.04 5.65187 10.52V8.26667C5.65187 6.85333 6.81188 5.69333 8.22521 5.69333H10.5319C11.0652 5.69333 11.8119 5.41333 12.2119 5.08L14.3319 3.26667Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10.84V17.28"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9922 21.3333H16.0042"
        stroke={stroke}
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
